var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, Fragment, useEffect, useMemo, useCallback, useRef, } from 'react';
import * as styles from './dropdown.styles';
import { Menu, Transition } from '@headlessui/react';
import { Typography } from '../typography/typography';
import { renderIcon } from '../../utils';
import { classNames } from '../../utils/style-class.utils';
import { CheckCircleIcon } from '@heroicons/react/solid';
export function Dropdown(_a) {
    var list = _a.list, selectedValue = _a.selectedValue, label = _a.label, subLabel = _a.subLabel, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.fillType, fillType = _d === void 0 ? 'filled' : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, _f = _a.fillColor, fillColor = _f === void 0 ? 'uiBg' : _f, _g = _a.textColor, textColor = _g === void 0 ? 'primary' : _g, className = _a.className, inputRef = _a.inputRef, showSearch = _a.showSearch, labelColor = _a.labelColor;
    var _h = useState(), selectedItem = _h[0], setSelectedItem = _h[1];
    var _j = useState(false), touched = _j[0], setTouched = _j[1];
    var _k = useState(''), search = _k[0], setSearch = _k[1];
    var _l = useState(false), isOpenMenu = _l[0], setIsOpenMenu = _l[1];
    var menuRef = useRef(null);
    var lowerSearch = search.toLowerCase();
    var filteredList = useMemo(function () { return list.filter(function (item) { return item.label.toLowerCase().includes(lowerSearch); }); }, [list, lowerSearch]);
    var options = showSearch ? filteredList : list;
    var onToggleMenu = function () { return setIsOpenMenu(function (prevState) { return !prevState; }); };
    var handler = function (item) {
        if (item.value === selectedValue) {
            return;
        }
        setSelectedItem(item);
        setSearch('');
        onChange(item.value);
        setTouched(true);
    };
    var renderSearchInput = useMemo(function () { return (_jsxs("div", __assign({ className: "relative" }, { children: [_jsx("input", { id: "search-input", value: search, onBlur: function (event) {
                    if (menuRef.current &&
                        !menuRef.current.contains(event.target)) {
                        setTimeout(function () { return setIsOpenMenu(false); }, 100);
                        onToggleMenu;
                    }
                }, type: "text", placeholder: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) ? selectedItem.label : placeholder, className: classNames(styles.title, styles.getDropDownFill(fillType, fillColor)), onChange: function (event) { return setSearch(event.target.value); }, onFocus: onToggleMenu, disabled: disabled }), _jsx("div", __assign({ onClick: function () {
                    onToggleMenu();
                } }, { children: renderIcon(!isOpenMenu ? 'ChevronDownIcon' : 'ChevronUpIcon', classNames(styles.getDropDownIcon(fillType, touched ? 'textDark' : 'textLight'), 'absolute top-3 right-0')) }))] }))); }, [
        search,
        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label,
        placeholder,
        fillType,
        fillColor,
        disabled,
        isOpenMenu,
        touched,
    ]);
    var renderMenuButton = useCallback(function (open) { return (_jsxs(Menu.Button, __assign({ className: classNames(styles.getDropDownFill(fillType, fillColor)), disabled: disabled }, { children: [_jsx(Typography, { type: 'body', color: labelColor ? labelColor : touched ? 'textDark' : 'textLight', text: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) ? selectedItem.label : placeholder, className: styles.title }), renderIcon(!open ? 'ChevronDownIcon' : 'ChevronUpIcon', styles.getDropDownIcon(fillType, labelColor ? labelColor : touched ? 'textDark' : 'textLight'))] }))); }, [fillType, fillColor, disabled, placeholder, touched, selectedItem]);
    useEffect(function () {
        if (selectedValue) {
            var filter = list.find(function (x) { return x.value === selectedValue; });
            setSelectedItem(filter);
        }
        else {
            setSelectedItem(undefined);
            setTouched(false);
        }
    }, [selectedValue, list]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpenMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var handleMenuItemClick = function (item) {
        handler(item);
        if (showSearch) {
            setIsOpenMenu(false);
        }
    };
    return (_jsxs("div", __assign({ className: className, ref: menuRef }, { children: [label && _jsx("label", __assign({ className: styles.label }, { children: label })), subLabel && _jsx("label", __assign({ className: styles.subLabel }, { children: subLabel })), _jsx(Menu, __assign({ as: "div", className: classNames(styles.menu, fullWidth ? 'w-full' : '') }, { children: function (_a) {
                    var open = _a.open;
                    return (_jsxs(_Fragment, { children: [showSearch ? renderSearchInput : renderMenuButton(open), _jsx(Transition, __assign({ show: showSearch ? isOpenMenu : open, as: Fragment, enter: styles.enter, enterFrom: styles.enterFrom, enterTo: styles.enterTo, leave: styles.leave, leaveFrom: styles.leaveFrom, leaveTo: styles.leaveTo }, { children: _jsx(Menu.Items, __assign({ static: true, className: styles.menuItems }, { children: options.length ? (options.map(function (item, index) {
                                        return (_jsx("div", __assign({ className: styles.menuItemWrapper }, { children: _jsx(Menu.Item, { children: function (_a) {
                                                    var active = _a.active;
                                                    return (_jsx("div", __assign({ className: item.value === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value)
                                                            ? styles.menuItemSelected
                                                            : styles.menuItem, onClick: function () { return handleMenuItemClick(item); } }, { children: _jsxs("div", __assign({ className: "text-md flex flex-row gap-2.5 text-".concat(item.value === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value)
                                                                ? 'dark font-medium'
                                                                : 'textDark font-normal') }, { children: [_jsx(CheckCircleIcon, { className: "h-6 w-6 cursor-pointer text-".concat(item.value === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value)
                                                                        ? 'secondary '
                                                                        : 'secondary') }), _jsx("p", { children: item.label })] })) })));
                                                } }) }), index));
                                    })) : (_jsx("p", __assign({ className: "text-textDark flex items-center justify-center" }, { children: "No results" }))) })) }))] }));
                } }))] })));
}
export default Dropdown;
//# sourceMappingURL=dropdown.js.map